import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ReportingTaxYearSettingModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/ReportingTaxYearSettingModel";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import { RegulatoryTabs } from "../../Resource/RegulatoryContents";
import { TableViewSection } from "../TableViewSection";

interface IReportingTaxYearSettingTableProps {
    customerid: number;
    hasReadWriteAccess: boolean;
}
interface IReportingTaxYearSettingTableState {
    data: Array<ReportingTaxYearSettingModel>;
    isLoading: boolean;
}
export class ReportingTaxYearSettingTable extends FormComponent<
    IReportingTaxYearSettingTableProps,
    IReportingTaxYearSettingTableState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
        };
    }
    componentDidMount() {
        this.getData();
    }

    getData() {
        this.setState({ isLoading: true });
        ClientRecordAction.getReportingTaxYearSetting(Number(this.props.customerid), (val) => {
            this.setState({
                data: val,
                isLoading: false,
            });
        });
    }

    render() {
        const { data, isLoading } = this.state;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        const columnConfigs = [
            {
                title: "Tax reporting country",
                key: "TaxReportingCountry",
                render: (x) => <span>{CountryCodeMap.getString(x)}</span>,
            },
        ];
        return (
            <>
                <TableViewSection
                    sectionHeader={RegulatoryTabs.ReportingTaxYearSetting}
                    columnConfigs={columnConfigs}
                    lightboxContent={(data, onDataChange) => this.renderLightBox(data, onDataChange)}
                    onAdd={(data) => this.onAdd(data)}
                    onRemove={(data) => this.onRemove(data)}
                    data={data}
                    canAdd={this.props?.hasReadWriteAccess == true}
                    canEdit={this.props?.hasReadWriteAccess == true}
                    canRemove={this.props?.hasReadWriteAccess == true}
                />
            </>
        );
    }

    renderLightBox(data: ReportingTaxYearSettingModel, onDataChange): JSX.Element {
        return (
            <>
                <SelectEditor
                    options={CountryCodeMap.getArray()}
                    getText={(v) => {
                        return CountryCodeMap.getString(v);
                    }}
                    placeholder="Please select"
                    label={"Tax reporting country*"}
                    required="Please select Country"
                    selected={data?.TaxReportingCountry}
                    cssWrapper="control-size-430"
                    onChange={(v) => {
                        onDataChange({ TaxReportingCountry: v });
                    }}
                />
            </>
        );
    }

    onAdd(item: ReportingTaxYearSettingModel): boolean {
        if (this.isValid()) {
            const { data } = this.state;
            data.push(item);
            this.saveData(data);
            return true;
        }
        return false;
    }

    onRemove(item: ReportingTaxYearSettingModel): boolean {
        const { data } = this.state;
        const index = data.findIndex((ele) => ele.TaxReportingCountry == item.TaxReportingCountry);
        data.splice(index, 1);
        this.saveData(data);
        return true;
    }

    saveData(data: Array<ReportingTaxYearSettingModel>) {
        ClientRecordAction.saveReportingTaxYearSetting(this.props.customerid, data, (val) => {
            this.getData();
        });
    }
}
